module.exports = __webpack_public_path__ + "assets/devices/Next-PG2-3ebb358187a4763dc7042a9af22c9508.svg";